import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/zh1';
export const locale = {
  lang: 'zh1',
  data: {
    'GENERICSURVEY': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': '通用調查報告',
      'SUBTITULO': '通過輸入查詢通用調查報告',
      'CAMPOS': {
        'Token': '代幣',
      },
      'RESULTADOS': {
        'CARGANDO': '加載搜索結果',
        'TITULO': '結果',
        'ENCONTRADAS': '找到的用戶總數',
        'DESCARGAR': '下載Excel格式的資料',
        'SINRESULTADOS': '找不到指定令牌的用戶'
      }
    }
  }
};
